import VueRouter from 'vue-router'
import Vue from 'vue'

import LoginPage from '../views/login'
import IndexPage from '../views/indexPage'
// import HomePage from '../views/homePage'
import PrdListPage from '../views/prdListPage'
import UserCenter from '../views/userCenter'
import PrdDetailPage from '../views/prdDetailPage'
import OrderList from '../views/orderList'
import OrderDetail from '../views/orderDetail'
import RefundDetail from '../views/refundDetail'
import CommentList from '../views/commentList'
import SuccessPage from '../views/successPage'
import LoginOutPage from '../views/loginOut'
import IndexPageNew from '../views/indexPageNew'
import AddressList from '../views/addressList'
import AddressDetail from '../views/addressDetail'
import CreateOrder from '../views/createOrder'
import CouponsList from '../views/couponsList'
import EditUserInfo from '../views/editUserInfo'
import MyCouponsList from '../views/myCouponsList'
import GetCoupons from '../views/getCoupons'

Vue.use(VueRouter)
const routes = [{
    path:'/login',
    component:LoginPage
},{
    path:'/indexPage',
    component:IndexPage,
    children:[
        {
            path:'/indexPageNew',
            component:IndexPageNew
        },{
            path:'/prdListPage',
            component:PrdListPage
        },{
            path:'/userCenter',
            component:UserCenter
        },{
            path:'/indexPageNew',
            component:IndexPageNew
        }
    ]
},{
    path:'/prdDetailPage',
    component:PrdDetailPage
},{
    path:'/orderList',
    component:OrderList
},{
    path:'/orderDetail',
    component:OrderDetail
},{
    path:'/refundDetail',
    component:RefundDetail
},{
    path:'/commentList',
    component:CommentList
},{
    path:'/successPage',
    component:SuccessPage
},{
    path:'/loginOut',
    component:LoginOutPage
},{
    path:'/addressList',
    component:AddressList
},{
    path:'/addressDetail',
    component:AddressDetail
},{
    path:'/createOrder',
    component:CreateOrder
},{
    path:'/couponsList',
    component:CouponsList
},{
    path:'/editUserInfo',
    component:EditUserInfo
},{
    path:'/myCouponsList',
    component:MyCouponsList
},{
    path:'/getCoupons',
    component:GetCoupons
}];
const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})
export default router